import React from 'react'
import styled from 'styled-components'

const GeneralCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const ContainerFilterItem = styled(GeneralCenter)`
    background: ${p => p.theme.palette.text.grayFullLight};
    justify-content: flex-start;
    border-radius: 50%;
    width: fit-content;
    border-radius: 50px;
    padding: 4px 8px;
    cursor: pointer;
    transition: .3s;

    :hover{
        background: ${p => p.theme.palette.primary.main};

        > div p,
        > div svg {
            color: white;
        }
    }
`
const ContainerText = styled.div`
    > p{
        color: ${p => p.theme.palette.text.gray};
        font-size: 13px;
        margin: 0;
    }
`
const ContainerIcon = styled.div`
    width: 15px;
    color: ${p => p.theme.palette.text.gray};
    margin-right: 10px;
`

interface IOwnProps{
    icon: React.ReactElement;
    text: string;
}

const FilterItem: React.FunctionComponent<IOwnProps> = ({
    icon,
    text,
}) => {
  return (
    <ContainerFilterItem>
        <ContainerIcon>
            {icon}
        </ContainerIcon>
        <ContainerText>
            <p>{text}</p>
        </ContainerText>
    </ContainerFilterItem>
  )
}

export default FilterItem;